import * as _ from 'lodash';

export class VrcFormValidations {
  static getErrorMsg(fieldName: string, validatorName: string, validatorValue?: any): any {
    const config = {
      required: `${fieldName} é obrigatório`,
      minlength: `Precisa ter no mínimo ${validatorValue.requiredLength} caractere(s)`,
      maxlength: `Precisa ter no máximo ${validatorValue.requiredLength} caractere(s)`,
      invalidfield: `${fieldName} inválido`,
    };

    return _.get(config, validatorName);
  }
}
